/** @format */

import { useQuery } from '@apollo/client';
import {
  GET_CAMPAIGNS_BY_OFFICE,
  CampaignsByOfficeData,
  CampaignsByOfficeVariables,
} from '../services/getCampaigns';
import { Campaign } from '../types';

interface UseCampaignsReturn {
  campaigns: Campaign[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Custom hook for fetching campaigns by office
 */
export const useCampaigns = (officeId?: string): UseCampaignsReturn => {
  const { data, loading, error, refetch } = useQuery<
    CampaignsByOfficeData,
    CampaignsByOfficeVariables
  >(GET_CAMPAIGNS_BY_OFFICE, {
    variables: { officeId },
    skip: !officeId,
  });

  const handleRefetch = async () => {
    await refetch();
  };

  return {
    campaigns: data?.campaignsByOffice || [],
    loading,
    error: error?.message || null,
    refetch: handleRefetch,
  };
};
